export function createGarmentContract({
  garment,
  defaults,
  compute,
  version,
  supportedVersions,
  migrate,
  blocks,
  displayOptions,
}) {
  return {
    garment,
    defaults,
    compute,
    version,
    supportedVersions,
    migrate,
    blocks,
    displayOptions,
  };
}

export function createIdentityMigrate(version) {
  return function migrateIdentity(patternLike = {}) {
    return {
      ...patternLike,
      geometry_version: patternLike?.geometry_version || version,
    };
  };
}
